import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchBox from '@/components/SearchBox.vue';
import SignInButton from '@/components/SignInButton.vue';
const uiModule = namespace('ui');
const authenticationModule = namespace('authentication');
const characterModule = namespace('character');
let MainToolbar = class MainToolbar extends Vue {
    constructor() {
        super(...arguments);
        this.isSearchOpen = false;
        this.toolbarLoading = true;
    }
    async mounted() {
        this.toolbarLoading = false;
    }
    resetSearch() {
        this.isSearchOpen = false;
    }
    get routes() {
        return [
            {
                to: '/',
                title: 'Home'
            },
            {
                to: '/rules',
                title: 'Rules',
                nested: [
                    { to: '/phb', title: 'Player\'s Handbook' },
                    { to: '/snv', title: 'Scum and Villainy' },
                    { to: '/sotg', title: 'Starships of the Galaxy' },
                    { to: '/wh', title: 'Wretched Hives' },
                    { to: '/variantRules', title: 'Variant Rules' },
                    { to: '/expandedContent', title: 'Expanded Content' }
                ]
            },
            {
                to: '/characters',
                title: 'Characters',
                nested: [
                    { to: '/species', title: 'Species' },
                    { to: '/classes', title: 'Classes' },
                    { to: '/archetypes', title: 'Archetypes' },
                    { to: '/backgrounds', title: 'Backgrounds' },
                    { to: '/feats', title: 'Feats' },
                    { to: '/customizationOptions', title: 'Customization Options' },
                    { to: '/forcePowers', title: 'Force Powers' },
                    { to: '/techPowers', title: 'Tech Powers' }
                ]
            },
            {
                to: '/loot',
                title: 'Loot',
                nested: [
                    { to: '/armor', title: 'Armor' },
                    { to: '/weapons', title: 'Weapons' },
                    { to: '/adventuringGear', title: 'Adventuring Gear' },
                    { to: '/enhancedItems', title: 'Enhanced Items' }
                ]
            },
            {
                to: '/starships',
                title: 'Starships',
                nested: [
                    { to: '/deployments', title: 'Deployments' },
                    { to: '/ventures', title: 'Ventures' },
                    { to: '/modifications', title: 'Modifications' },
                    { to: '/equipment', title: 'Equipment' },
                    { to: '/weapons', title: 'Weapons' }
                ]
            },
            {
                to: '/tools',
                title: 'Tools',
                nested: [
                    { to: '/mycharacters', title: 'Character Creator' }
                ]
            },
            {
                to: '/assets',
                title: 'Assets'
            },
            {
                to: '/credits',
                title: 'Credits'
            }
        ];
    }
    get isPageWithNavigation() {
        return ['phb', 'wh', 'sotg', 'snv'].some(page => this.$route.path.includes(page));
    }
    get darkColor() {
        return this.$vuetify.theme.dark ? '' : 'primary';
    }
    buildComponentProps(to, nested) {
        return nested && nested.length ? {
            is: 'v-menu',
            'open-on-hover': true,
            'offset-y': true,
            attach: true
        } : {
            is: 'v-btn',
            text: true,
            color: this.darkColor,
            to
        };
    }
    handleSideIconClick() {
        this.updateSideBar(true);
    }
    logOut() {
        Promise.all([
            this.setAccessToken(),
            this.clearLocalCharacters()
        ]).then(() => {
            Vue.prototype.$msal && Vue.prototype.$msal.logoutRedirect({
                postLogoutRedirectUri: window.location.pathname + '#logged-out'
            });
        });
    }
};
__decorate([
    uiModule.State
], MainToolbar.prototype, "isSideBarOpen", void 0);
__decorate([
    uiModule.State
], MainToolbar.prototype, "isDarkSide", void 0);
__decorate([
    uiModule.Action
], MainToolbar.prototype, "updateSideBar", void 0);
__decorate([
    authenticationModule.Getter
], MainToolbar.prototype, "isLoggedIn", void 0);
__decorate([
    authenticationModule.Action
], MainToolbar.prototype, "setAccessToken", void 0);
__decorate([
    authenticationModule.State
], MainToolbar.prototype, "isAuthLoading", void 0);
__decorate([
    authenticationModule.Action
], MainToolbar.prototype, "setIsAuthLoading", void 0);
__decorate([
    characterModule.Action
], MainToolbar.prototype, "clearLocalCharacters", void 0);
__decorate([
    Watch('$route')
], MainToolbar.prototype, "resetSearch", null);
MainToolbar = __decorate([
    Component({
        components: {
            SearchBox,
            SignInButton
        }
    })
], MainToolbar);
export default MainToolbar;
